module.exports = __webpack_public_path__ + "img/coupon-active.25ae17f2.svg";